module.exports = __webpack_public_path__ + "img/product_24.08eb653.webp";